import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _excluded = ["buttonText", "collapsed", "sources"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import styles from "./SourcesSlice.module.scss";
import { Container } from "../../Container/Container/Container";
import { CollapsiblePanel } from "../../CollapsiblePanel/CollapsiblePanel";
import { Source } from "../../Source/Source";
import { jsx as _jsx } from "react/jsx-runtime";
export var SourcesSlice = function SourcesSlice(_ref) {
  var _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? 'See our sources' : _ref$buttonText,
    _ref$collapsed = _ref.collapsed,
    collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
    sources = _ref.sources,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var renderSources = function renderSources(sources) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.childrenContainer,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.childrenContent,
        children: sources === null || sources === void 0 ? void 0 : sources.map(function (source, key) {
          return /*#__PURE__*/_jsx("div", {
            className: styles.child,
            children: source.text && /*#__PURE__*/_jsx(Source, {
              text: source.text
            })
          }, key);
        })
      })
    });
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx("div", {
      className: styles.wrapper,
      children: /*#__PURE__*/_jsx(CollapsiblePanel, _objectSpread(_objectSpread({
        buttonText: buttonText,
        className: styles.buttonText,
        collapsed: collapsed,
        collapsible: true,
        contentOuterClassName: styles.panel,
        labels: {
          close: "Click to close ".concat(buttonText, " panel"),
          open: "Click to open ".concat(buttonText, " panel")
        },
        variant: 'border-lg'
      }, otherProps), {}, {
        children: renderSources(sources)
      }))
    })
  });
};